/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { ITokenModel } from "../models";
import { StorageHelper } from "./storageHelper";

export class AuthorizationHelper {
  static async isLoggedIn(): Promise<boolean> {
    const session = await this.session();
    return !!session;
  }

  static async isAuthenticated(): Promise<boolean> {
    const session = StorageHelper.getSession();

    if (!session) return false;

    return session && session.Token !== undefined;
  }

  static async session(): Promise<ITokenModel | undefined> {
    return await StorageHelper.getSession();
  }
}
